<template>
    <div class="module-box">
        <div class="module-countainer">
            <el-tooltip class="box-item" effect="light" content="添加" placement="bottom">
                <el-button
                    type="primary"
                    plain
                    size="small"
                    :icon="Plus"
                    v-permission="['base:manufacturer:add']"
                    style="width: 25px"
                    @click="onAddClick"
                ></el-button>
            </el-tooltip>
            <el-tooltip class="box-item" effect="light" content="编辑" placement="bottom">
                <el-button
                    type="success"
                    plain
                    size="small"
                    v-permission="['base:manufacturer:edit']"
                    :disabled="!currentClickGroupId"
                    :icon="Edit"
                    @click="onEditClick"
                    style="width: 25px"
                ></el-button>
            </el-tooltip>
            <el-tooltip class="box-item" effect="light" content="导入" placement="bottom">
                <el-button
                    type="info"
                    plain
                    size="small"
                    :icon="Download"
                    style="width: 25px"
                    v-permission="['base:manufacturer:import']"
                    @click="uploadVisible = true"
                ></el-button>
            </el-tooltip>
            <el-tooltip class="box-item" effect="light" content="导出" placement="bottom">
                <el-button
                    type="warning"
                    plain
                    size="small"
                    :icon="Upload"
                    style="width: 25px"
                    v-permission="['base:manufacturer:export']"
                    @click="handleExport()"
                ></el-button>
            </el-tooltip>
            <el-tooltip class="box-item" effect="light" content="删除   " placement="bottom">
                <el-button
                    type="danger"
                    plain
                    size="small"
                    :disabled="!currentClickGroupId"
                    :icon="Delete"
                    v-permission="['base:manufacturer:delete']"
                    style="width: 25px"
                    @click="onRemoveClick"
                ></el-button>
            </el-tooltip>
        </div>
        <!-- <h4 class="card-headers">
            <el-icon>
                <Expand />
            </el-icon>
            设备类型管理
            <el-tooltip class="box-item" effect="dark" content="新增配置组" placement="top-start">
                <el-icon class="circlePlusFilled" style="margin-left: auto" v-permission="['equip:model:add']">
                    <CirclePlusFilled color="var(--theme-color)" @click="onAddClick" />
                </el-icon>
            </el-tooltip>
        </h4> -->

        <ul style="height: calc(100vh - 164px)">
            <el-scrollbar height="calc(100vh - 160px)">
                <li @click="changeGroup(null)" :class="!currentClickGroupId ? 'active' : ''">全部</li>
                <li
                    v-for="item in tableDate"
                    :key="item.id"
                    @click="changeGroup(item)"
                    class="li-item"
                    :class="item.id == currentClickGroupId ? 'active' : ''"
                >
                    <span class="typeName">{{ item.name }}</span>
                    <!-- <el-dropdown class="dot">
                    <span class="ellipsis">···</span>
                    <template #dropdown>
                        <el-dropdown-menu>
                            <el-dropdown-item>修改</el-dropdown-item>
                            <el-dropdown-item @click="onRemoveClick(item)" v-permission="['equip:type:remove']">删除</el-dropdown-item>
                        </el-dropdown-menu>
                    </template>
                </el-dropdown> -->
                </li>
            </el-scrollbar>
        </ul>
    </div>
    <AddEquiType v-model="formDialogVisible" :isForm="isForm" :equTypeId="equTypeId" @updateForm="getEquipTypelListFun" />
    <imports-form
        v-if="uploadVisible"
        v-model="uploadVisible"
        @updateForm="getEquipTypelListFun"
        menuCode="manufacturer"
    ></imports-form>
</template>

<script setup>
import { defineEmits, onMounted, ref, watch } from 'vue'
import { Delete, Download, Edit, Plus, Upload } from '@element-plus/icons'
import { delManufacturerType, getExportManufacturerLists, getManufacturerLists } from '@/api/deviceBrand/deviceBrandFactory'
import AddEquiType from './AddEquiType.vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import ImportsForm from '@/components/ImportsForm.vue'

const emits = defineEmits(['change', 'updateForm'])
const tableDate = ref([])
// 导入弹框
const uploadVisible = ref(false)
// 列表
const getEquipTypelListFun = async () => {
    const data = await getManufacturerLists()
    emits('updateForm')
    // console.log(data)
    tableDate.value = data
}

// 操作
const isForm = ref(false)
const equTypeId = ref('')
const formDialogVisible = ref(false)
const onAddClick = () => {
    equTypeId.value = ''
    isForm.value = true
    formDialogVisible.value = true
}
const currentClickGroupId = ref('')
const currentClickGroupItem = ref({})
// 切换列表项
const changeGroup = (item) => {
    if (item !== null) {
        emits('change', item.id)
        currentClickGroupId.value = item.id
        currentClickGroupItem.value = item
    } else {
        emits('change', item)
        currentClickGroupId.value = item
    }
}
// 编辑
const onEditClick = () => {
    equTypeId.value = currentClickGroupId.value
    isForm.value = true
    formDialogVisible.value = true
}

// 删除

const onRemoveClick = (row) => {
    ElMessageBox.confirm('确定要删除 ' + currentClickGroupItem.value.name + ' 吗？', {
        type: 'warning'
    })
        .then(async () => {
            await delManufacturerType(currentClickGroupId.value)
            ElMessage.success('删除成功！')
            // 重新渲染数据
            getEquipTypelListFun()
            emits('change', null)
            currentClickGroupId.value = null
        })
        .catch(() => {})
}

// 导出
const handleExport = async () => {
    ElMessageBox.confirm('您确定导出全部型号及类别吗？', {
        type: 'warning'
    })
        .then(async () => {
            const { data } = await getExportManufacturerLists({ ...tableDate.value, export: 1 })
            window.open(data)
            ElMessage.success('导出成功')
        })
        .catch(() => {})
}

watch(formDialogVisible, (val) => {
    if (!val) equTypeId.value = ''
})

/**
 * 被 keep-alive 缓存的组件激活时调用
 */
onMounted(() => {
    getEquipTypelListFun()
})
</script>

<style lang="scss" scoped>
.module-box {
    min-width: 180px;
    height: calc(100vh - 130px);
    background-color: #fafcfe;
    padding: 5px 0;
    box-sizing: border-box;
    font-size: 14px;
    border-right: 1px solid #d9d9e1;
    margin-top: -10px;
    border-bottom-left-radius: 8px;
    .module-countainer {
        margin: 8px 3px 10px;
        min-width: 173px;
        display: flex;
        justify-content: space-between;
        button {
            margin: 0;
        }
    }
    h4 {
        padding: 10px 10px;
        line-height: 28px;
        font-weight: normal;
        color: #7c7e82;
        // border-bottom: 1px solid #ddd;
        font-size: 14px;
        display: flex;
        align-items: center;
    }

    li {
        padding: 12px 20px;
        cursor: pointer;
        position: relative;
        color: #232323;
        overflow: hidden;
        text-overflow: ellipsis;
        display: flex;
        justify-content: space-between;
        .typeName {
            display: inline-block;
            width: 80%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        &:hover {
            background-color: var(--el-color-primary-light-9);
        }
    }

    .active {
        background-color: var(--el-color-primary-light-9);

        &::after {
            position: absolute;
            right: -1px;
            top: 0;
            content: '';
            width: 2px;
            height: 100%;
            background-color: #4291f7;
        }
    }

    .cell {
        width: 250px !important;
    }
}
</style>
